import React, { useContext } from "react";
import { useDispatch, useSelector } from "react-redux";
import ModalRightSideBarTemplate from "../ModalRightSideBarTemplate";
import { isModalNavbarMobileSelector } from "../../selectors/AppSelectors";
import { modalNavbarMobileAction } from "../../actions/AppActions";
import { BOOK_DESK_LINK, DESK_BOOKING_LINK } from "../../configs/ListRoutes";
import { PUBLIC_URL } from "../../configs/Constants";
import { Link, useNavigate } from "react-router-dom";
import ButtonCustom from "../../../../components/Button";
import "./style.scss";
import { LocalizationContext } from "../../../../locales/Translation";
import BookIcon from "../NavBar/Components/BookIcon";

const NavBarBusinessUserMobile = () => {
  const { translations } = useContext(LocalizationContext);

  const dispatch = useDispatch();
  const isModalNavbarMobile = useSelector(isModalNavbarMobileSelector);
  const navigate = useNavigate();

  const _onClick = (pathName: string) => {
    navigate(pathName, { replace: true });
    dispatch(modalNavbarMobileAction(false));
  };

  return (
    <ModalRightSideBarTemplate
      trigger={null}
      onClose={() => {
        dispatch(modalNavbarMobileAction(false));
      }}
      modalClassName={"modal-edit-employee"}
      open={isModalNavbarMobile}
    >
      <div className={"navbar-mobile__list"}>
        <div className={"d-flex justify-content-between"}>
          <Link to={BOOK_DESK_LINK} className={"navbar__logo"}>
            <img src={PUBLIC_URL + "/assets/logo.svg"} alt="deskimo-logo" />
          </Link>
          <ButtonCustom
            onClick={() => dispatch(modalNavbarMobileAction(false))}
            className={"m-0 p-0 none-bg close-modal"}
          >
            <>
              {translations.close}
              <img src={PUBLIC_URL + "/assets/icons/icon-close-grey.svg"} />
            </>
          </ButtonCustom>
        </div>

        <div className={"navbar-mobile__links"}>
          <div
            className={"navbar-mobile__link"}
            onClick={() => {
              _onClick(BOOK_DESK_LINK);
            }}
          >
            <BookIcon />
            {translations.book}
          </div>

          <div
            className={"navbar-mobile__link"}
            onClick={() => {
              _onClick(DESK_BOOKING_LINK);
            }}
          >
            <i className="uil uil-list-ul" />
            {translations.myActivities}
          </div>
        </div>
      </div>
    </ModalRightSideBarTemplate>
  );
};

export default NavBarBusinessUserMobile;
